import { EzSchedule } from './ez-schedule.model';
import { EzProjectDetails } from './ez-project-details.model';
export class EnterpriseZoneApplication {
  public ezSchedule: EzSchedule;
  public ezProjectDetails: EzProjectDetails;
  constructor() { }
}